/*********************** here will be the code for ADD CART BUTTON ***********************/

/*********************** here will be the code for ADD CART BUTTON ***********************/

function addGreyToCart(productId) {
    const selectElement = document.getElementById('gr_' + productId);
    const buttonElement = event.target.closest('button');
    const buttonText = buttonElement.querySelector('span');
    const originalText = buttonText.textContent;
    
    // Disable button and change text
    buttonElement.disabled = true;
    buttonText.textContent = 'Adding...';
    
    let variantId = null;
    
    // If there's a select box, get the selected variant
    if (selectElement) {
      if (selectElement.value) {
        variantId = selectElement.value;
      } else {
        // Variant not selected
        alert('Please select a variant first');
        // Re-enable button and restore text
        buttonElement.disabled = false;
        buttonText.textContent = originalText;
        return;
      }
    } else {
      // No select element - product has only default variant
      // We need to get the default variant ID from the product data
      const productContainer = document.getElementById('product_gr_' + productId);
      if (productContainer) {
        // Try to get variant ID from a hidden input or data attribute
        const hiddenInput = productContainer.querySelector('input[name="product_id_grey"]');
        if (hiddenInput && hiddenInput.dataset.variantId) {
          variantId = hiddenInput.dataset.variantId;
        } else {
          // Fallback: use product ID as variant ID (this should work for default variants)
          variantId = productId;
        }
      }
    }
    
    // If we still don't have a variant ID, show error
    if (!variantId) {
      alert('Unable to determine product variant');
      buttonElement.disabled = false;
      buttonText.textContent = originalText;
      return;
    }
    
    // Get quantity (default to 1)
    const quantity = 1;
    
    // Prepare the data for cart addition
    const formData = {
      id: variantId,
      quantity: quantity
    };
    
    // Add to cart using Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      if (data.status) {
        // Error occurred
        alert('Error: ' + data.description);
      } else {
        // Success - update cart count and show success message
        updateCartCount();
        showSuccessMessage('Product added to cart!');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('Error adding product to cart. Please try again.');
    })
    .finally(() => {
      // Re-enable button and restore text
      buttonElement.disabled = false;
      buttonText.textContent = originalText;
    });
  }
  
  function updateCartCount() {
    // Update cart-drawer content
    updateCartDrawer();
    // Update cart count and amount in header
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function(cart) {
        // Update cart count
        var $cartCountBubble = $('.cart-count-bubble');
        var cartCountHtml = '<span aria-hidden="true">' + cart.item_count +
            '</span><span class="visually-hidden">' + cart.item_count + ' items</span>';
        if ($cartCountBubble.length) {
          $cartCountBubble.html(cartCountHtml);
        } else {
          // If element doesn't exist, create and add it to header
          var $cartIcon = $('#cart-icon-bubble');
          if ($cartIcon.length) {
            var $newBubble = $('<div class="cart-count-bubble"></div>').html(cartCountHtml);
            $cartIcon.append($newBubble);
          }
        }

        // Update cart amount
        var $cartAmountElement = $('#header-cart-amount');
        if ($cartAmountElement.length && cart.total_price) {
          // Convert cents to currency
          var totalPrice = (cart.total_price / 100).toFixed(2);
          // Format as currency (GBP)
          $cartAmountElement.text('£' + totalPrice);
        }
        
      },
      error: function(xhr, status, error) {
        console.error('Error updating cart:', error);
      }
    });
  }
  
  function updateCartDrawer() {
    // Update cart-drawer content via AJAX
    $.ajax({
      url: '/cart?section_id=cart-drawer',
      method: 'GET',
      success: function(response) {
        var $response = $(response);
        var $newCartDrawer = $response.find('#CartDrawer');
        
        if ($newCartDrawer.length) {
          // Update cart-drawer content
          var $currentCartDrawer = $('#CartDrawer');
          if ($currentCartDrawer.length) {
            $currentCartDrawer.html($newCartDrawer.html());
            $('cart-drawer').removeClass('is-empty');
          }
        }
      },
      error: function(xhr, status, error) {
        console.error('Error updating cart drawer:', error);
      }
    });
  }
  

  
  // Update price when variant is selected
  $(document).ready(function() {
    $('.ptg_info_opt_gr select').on('change', function() {
      var $selectedOption = $(this).find('option:selected');
      var $priceContainer = $(this).closest('.ptg_info_price_opt').find('.ptg_info_price .price_pr');
      if ($selectedOption.data('price') && $priceContainer.length) {
        var priceText = $selectedOption.data('price');
        if (typeof priceText === 'string' && priceText.indexOf('coming soon') !== -1) {
          $priceContainer.html('coming soon');
        } else {
          $priceContainer.html(priceText);
        }
      }
    });

    // Инициализация кнопки добавления в корзину
    initializeAddToCartButton();
  });
  
 
  
  // Initialize add to cart button functionality
  function initializeAddToCartButton() {
    $(document).on('click', '.product-form__submit', function(e) {
      e.preventDefault();
      
      const $form = $(this).closest('form');
      const variantId = $form.find('input[name="id"]').val();
      const quantity = parseInt($('#qty_main_input').val()) || 1;
      
      if (!variantId) {
        showErrorMessage('Variant not selected');
        return;
      }
      
      // Show loading state
      const $button = $(this);
      const originalText = $button.find('span').text();
      $button.prop('disabled', true);
      $button.find('span').text('Adding...');
      
      // Собираем все товары для добавления в корзину
      const items = [];
      
      // Добавляем основной товар
      items.push({
        id: parseInt(variantId),
        quantity: quantity
      });
      
      // Добавляем отмеченные upsell товары
      $('.upsell_pr_wr input[type="checkbox"]:checked').each(function() {
        var upsellVariantId = $(this).val();
        if (upsellVariantId && !isNaN(upsellVariantId)) {
          items.push({
            id: parseInt(upsellVariantId),
            quantity: 1
          });
        }
      });

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        success: function(data) {
          // Update cart count
          updateCartCount();
          
          // Show success message
          const totalItems = items.length;
          if (totalItems === 1) {
            showSuccessMessage('Product added to cart successfully!');
          } else {
            showSuccessMessage(totalItems + ' products added to cart successfully!');
          }
        },
        error: function(xhr, status, error) {
          console.error('Error adding to cart:', error);
          
          if (xhr.responseJSON && xhr.responseJSON.description) {
            showErrorMessage('Error: ' + xhr.responseJSON.description);
          } else {
            showErrorMessage('Error adding products to cart. Please try again.');
          }
        },
        complete: function() {
          // Re-enable button and restore text
          $button.prop('disabled', false);
          $button.find('span').text(originalText);
        }
      });
    });
  }